import { Component, OnInit, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral } from '@agm/core';
import { environment as params } from 'src/environments/environment';
declare var google: any;

@Component({
  selector: 'app-suc-map',
  templateUrl: './suc-map.component.html',
  styleUrls: ['./suc-map.component.scss']
})
export class SucMapComponent implements OnInit, OnChanges {
  @Input() public data: any;
  @Input() public km: any = 500;
  @Input() public optionsPage: any;
  public urlMark: String = 'http://maps.gstatic.com/mapfiles/markers2/marker.png';
  public comoLlegarTxt: any;
  @ViewChild('AgmMap') agmMap: AgmMap;
  public markersShow: any;
  public lat: number;
  public lng: number;
  public zoom: number;
  public markerUbicacion: any;
  public styles: any;
  protected map: any;
  public icon: any;
  urlBaseS3: any = (<any>params).api.s3;
  public routeMap: boolean;
  public origin: any;
  public destination: any;
  public renderOptions = {
    suppressMarkers: true,
  };

  public markerOptions: any = {
    origin: {},
    destination: {},
  };

  constructor() {
    this.lat = 19.432697;
    this.lng = -99.133261;
  }

  ngOnInit() {
    this.urlMark = this.urlBaseS3 + this.optionsPage.icon_marker.url;
    this.comoLlegarTxt = this.optionsPage.text_boton_marker;
    this.icon = {
      url: this.urlMark
    };
    this.markerOptions.origin.icon = this.urlBaseS3 + this.optionsPage.icon_marker_two.url;
    this.markerOptions.destination.icon = this.urlMark;
    this.markersShow = this.data;
    this.getCenter();
    this.getZoom();
  }
  mapReady(map) {
    this.map = map;
  }
  getAddress(sucursal) {
    return `${sucursal.calle} ${sucursal.numext}, Col. ${sucursal.colonia}, Del. ${sucursal.delegacion}`;
  }
  comoLlegar(id) {
    const find = this.data.find(e => e.id_post == id);
    if (find) {
      this.markersShow = [];
      this.destination = { lat: find.latitud, lng: find.longitud };
      this.markerOptions.destination.infoWindow = 'Destino:  Sucursal ' + find.nombre;

      if (navigator.geolocation) {
        if (sessionStorage.getItem('location')) {
          const miGPS = JSON.parse(sessionStorage.getItem('location'));
          this.origin = { lat: miGPS.lat, lng: miGPS.lon };
          this.routeMap = true;
        }
        navigator.geolocation.watchPosition((position) => {
          const coors = {lat: position.coords.latitude, lon: position.coords.longitude};
          sessionStorage.setItem('location', JSON.stringify(coors));
          this.origin = { lat: coors.lat, lng: coors.lon };
          this.routeMap = true;
        }, err => {
          console.error('Error al obtener ubicación ', err);
        });
      } else {
        alert('Geolocation is not supported by this browser.');
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Algo Cambioo: ', this.data, this.lat, this.lng);
    this.markersShow = this.data;
    this.getCenter();
    this.getZoom();
  }
  getCenter() {
    this.routeMap = false;
    if (this.markersShow.length > 0) {
      let lt = 0;
      let ln = 0;
      this.markersShow.forEach(e => {
        lt += e.latitud;
        ln += e.longitud;
      });
      this.lat = lt / this.markersShow.length;
      this.lng = ln / this.markersShow.length;
      const paramsCenter = { lat: this.lat, lng: this.lng };
      if (this.map !== undefined) {
        this.map.setCenter(paramsCenter);
      }
    }
  }
  getZoom() {
    this.zoom = 5;
    if (this.km >= 0 && this.km !== 500) {
      this.zoom = this.getZoomKm(this.km);
    }
  }
  getZoomKm(km) {
    if (km === 0) {
      return 16;
    } else if (km <= 1) {
      return 15;
    } else if (km <= 2) {
      return 14;
    } else if (km <= 5) {
      return 13;
    } else if (km <= 10) {
      return 12;
    } else if (km <= 20) {
      return 11;
    } else if (km <= 30) {
      return 10;
    }
  }
  stylesMap() {
    this.styles = [
      {
        'featureType': 'landscape',
        'stylers': [
          {
            'color': '#e0efef'
          }
        ]
      },
      {
        'featureType': 'poi',
        'stylers': [
          {
            'color': '#c0e8e8'
          }
        ]
      },
      {
        'featureType': 'road',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'water',
        'stylers': [
          {
            'color': '#7dcdcd'
          }
        ]
      }
    ];
  }
}
